export default __webpack_public_path__ + "static/media/taxAdministrationImg.63e216a9.svg";